import ButtonOld from './Button.old';
import ButtonGl2025 from './ButtonGl2025Adapter';
import { ThemeComponentSwitcher } from '../styling/index';


const Button = ThemeComponentSwitcher([
    { theme: 'gl2025', component: ButtonGl2025 },
    { theme: 'old', component: ButtonOld }
]);

export default Button;